import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  orderBy,
  serverTimestamp
} from "firebase/firestore";

import { db } from "./firebase";

const COLLECTION = "sessions";

// =======================================
// CREATE SESSION
// =======================================

export async function createSession(uid, session) {
  const docRef = await addDoc(
    collection(db, COLLECTION),
    {
      uid,
      ...session,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    }
  );

  return docRef.id;
}

// =======================================
// LOAD USER SESSIONS
// =======================================

export async function getUserSessions(uid) {
  const q = query(
    collection(db, COLLECTION),
    where("uid", "==", uid),
    orderBy("updatedAt", "desc")
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map((docSnap) => ({
    firebaseId: docSnap.id,
    ...docSnap.data(),
  }));
}

// =======================================
// UPDATE ENTIRE SESSION
// =======================================

export async function updateSession(firebaseId, updates) {
  await updateDoc(
    doc(db, COLLECTION, firebaseId),
    {
      ...updates,
      updatedAt: serverTimestamp(),
    }
  );
}

// =======================================
// SAVE CHAT MESSAGES
// =======================================

export async function saveMessages(firebaseId, messages) {
  await updateDoc(
    doc(db, COLLECTION, firebaseId),
    {
      messages,
      messageCount: messages.length,
      lastMessage:
        messages[messages.length - 1]?.text ||
        messages[messages.length - 1]?.content ||
        "",
      updatedAt: serverTimestamp(),
    }
  );
}

// =======================================
// RENAME SESSION
// =======================================

export async function renameSession(firebaseId, newName) {
  await updateDoc(
    doc(db, COLLECTION, firebaseId),
    {
      name: newName,
      updatedAt: serverTimestamp(),
    }
  );
}

// =======================================
// DELETE SESSION
// =======================================

export async function deleteSession(firebaseId) {
  await deleteDoc(
    doc(db, COLLECTION, firebaseId)
  );
}